// Put this at the start and end of an inline component to work around this Chromium bug:
// https://bugs.chromium.org/p/chromium/issues/detail?id=1249405

export default function InlineFix() {
  return (
    <span contentEditable={false} style={{ fontSize: 0 }}>
      {String.fromCodePoint(160)}
    </span>
  );
}
